import { FC, useEffect, useRef, useState } from "react";
import shop01 from "../../../Assets/homev2/Navbar/shop-01.png";
import shop02 from "../../../Assets/homev2/Navbar/shop-02.png";
import shop03 from "../../../Assets/homev2/Navbar/shop-03.png";
import shop1 from "../../../Assets/homev2/Navbar/shop-1.mp4";
import shop2 from "../../../Assets/homev2/Navbar/shop-2.mp4";
import shop3 from "../../../Assets/homev2/Navbar/shop-3.mp4";

interface OnDemandImageProps {
  src2: string;
  src: string;
  alt: string;
}

export const shopData = [
	{
		title: "Sales & Strategy",
		link: "/reach-out?services=sales-strategy",
		items: [
			{
				title: "Sales Team OnDemand",
				link: "/reach-out?services=sales-strategy",
				withTradeMark: true,
			},
			{
				title: "Strategy & Consulting",
				link: "/reach-out?services=sales-strategy",
			},
			{
				title: "Sales Support",
				link: "/reach-out?services=sales-strategy",
			},
		],
	},
	{
		title: "Business Dev",
		link: "/reach-out?services=business-development",
		items: [
			{
				title: "Campaigns OnDemand",
				link: "/reach-out?services=business-development",
				withTradeMark: true,
			},
			{
				title: "Lead Generation",
				link: "/reach-out?services=business-development",
			},
			{
				title: "Email Campaign",
				link: "/reach-out?services=business-development",
			},
			{
				title: "LinkedIn Campaign",
				link: "/reach-out?services=business-development",
			},
			{
				title: "Sales Calls",
				link: "/reach-out?services=business-development",
			},
			{
				title: "Text Campaigns",
				link: "/reach-out?services=business-development",
			},
		],
	},
	{
		title: "Brand & Creative",
		link: "/reach-out?services=brand-creative",
		items: [
			{
				title: "Creative OnDemand",
				link: "/reach-out?services=brand-creative",
				withTradeMark: true,
			},
			{
				title: "Brand Strategy",
				link: "/reach-out?services=brand-creative",
			},
			{
				title: "Logo Design",
				link: "/reach-out?services=brand-creative",
			},
			{
				title: "Stationery Design",
				link: "/reach-out?services=brand-creative",
			},
			{
				title: "Presentation Templates",
				link: "/reach-out?services=brand-creative",
			},
			{
				title: "Full Brand Creation",
				link: "/reach-out?services=brand-creative",
			},
		],
	},
	{
		title: "Digital Marketing",
		link: "/reach-out?services=digital-marketing",
		items: [
			{
				title: "Marketing OnDemand",
				link: "/reach-out?services=digital-marketing",
				withTradeMark: true,
			},
			{
				title: "SEO Analysis",
				link: "/reach-out?services=digital-marketing",
			},
			{
				title: "SEO Optimization",
				link: "/reach-out?services=digital-marketing",
			},
			{
				title: "Social Media Management",
				link: "/reach-out?services=digital-marketing",
			},
			{
				title: "Paid Ads",
				link: "/reach-out?services=digital-marketing",
			},
		],
	},
	{
		title: "Copy & Content",
		link: "/reach-out?services=copy-content",
		items: [
			{
				title: "Copy OnDemand",
				link: "/reach-out?services=copy-content",
				withTradeMark: true,
			},
			{
				title: "Content OnDemand",
				link: "/reach-out?services=copy-content",
				withTradeMark: true,
			},
			{
				title: "Website Content",
				link: "/reach-out?services=copy-content",
			},
			{
				title: "Content Strategy",
				link: "/reach-out?services=copy-content",
			},
			{
				title: "Content Management",
				link: "/reach-out?services=copy-content",
			},
			{
				title: "Content Creation",
				link: "/reach-out?services=copy-content",
			},
			{
				title: "Articles & Blogs",
				link: "/reach-out?services=copy-content",
			},
		],
	},
	{
		title: "Video Production",
		link: "/reach-out?services=video-production",
		items: [
			{
				title: "Video OnDemand",
				link: "/reach-out?services=video-production",
				withTradeMark: true,
			},
			{
				title: "Video Marketing",
				link: "/reach-out?services=video-production",
			},
			{
				title: "VSF",
				link: "/reach-out?services=video-production",
			},
			{
				title: "Packages",
				link: "/reach-out?services=video-production",
			},
			{
				title: "Types",
				link: "/reach-out?services=video-production",
			},
			{
				title: "Explainer",
				link: "/reach-out?services=video-production",
			},
			{
				title: "Live Action",
				link: "/reach-out?services=video-production",
			},
		],
	},
	{
		title: "Web & Tech",
		link: "/reach-out?services=ai-tech",
		items: [
			{
				title: "Dev OnDemand",
				link: "/reach-out?services=ai-tech",
				withTradeMark: true,
			},
			{
				title: "Web",
				link: "/reach-out?services=ai-tech",
			},
			{
				title: "Funnels",
				link: "/reach-out?services=ai-tech",
			},
			{
				title: "Mobile",
				link: "/reach-out?services=ai-tech",
			},
			{
				title: "Digital Products",
				link: "/reach-out?services=ai-tech",
			},
		],
	},
	{
		title: "Build My Team",
		link: "/reach-out?services=build-my-team",
		items: [
			{
				title: "Team OnDemand",
				link: "/reach-out?services=build-my-team",
				withTradeMark: true,
			},
			{
				title: "Resource",
				link: "/reach-out?services=build-my-team",
			},
			{
				title: "Fractional Roles",
				link: "/reach-out?services=build-my-team",
			},
			{
				title: "Recruiting",
				link: "/reach-out?services=build-my-team",
			},
			{
				title: "Coaching",
				link: "/reach-out?services=build-my-team",
			},
		],
	},
];

const ShopNavMenu: FC = () => {
  const [menuOpen, setMenuOpen] = useState<number | null>(null);

  // const shopMenuCloseTimeOutRef = useRef<number | NodeJS.Timeout>();

  const handleMouseOvershopMenuZone = (menuType: number): void => {
    // console.log("shop timeout", shopMenuCloseTimeOutRef.current);

    // clearTimeout(shopMenuCloseTimeOutRef.current);
    // console.log("shop timeout cleared", shopMenuCloseTimeOutRef.current);
    // shopMenuCloseTimeOutRef.current = undefined;
    setMenuOpen(menuType);
  };
  const handleMouseOverNotshopMenuZone = () => {
    if (!!menuOpen) {
      // let shopMenuCloseTimeOut;
      // if (!shopMenuCloseTimeOutRef.current) {
      //   shopMenuCloseTimeOut = setTimeout(() => setMenuOpen(null), 1500);
      // }
      setMenuOpen(null);
      // console.log(
      //   "shop timeout created",
      //   shopMenuCloseTimeOut,
      //   shopMenuCloseTimeOutRef.current
      // );
      // shopMenuCloseTimeOutRef.current = shopMenuCloseTimeOut;
    }
  };

  return (
    <div className="w-full max-w-[1500px] mx-auto flex justify-between py-8 px-4">
      <div
        className="w-[20rem] relative"
        onMouseLeave={() => handleMouseOverNotshopMenuZone()}
      >
        <div className="space-y-6 relative z-[3] bg-white pr-10">
          {shopData.map((data, index) => {
            return (
              <div
                key={index}
                className="flex items-center justify-between text-black hover:text-[#84CC16] transition-all duration-300 ease-in-out cursor-pointer"
                onMouseEnter={(e) => {
                  e.stopPropagation();
                  handleMouseOvershopMenuZone(index);
                }}
              >
                <a href={data.link}>{data.title}</a>
                <svg
                  width="8.25"
                  height="15"
                  viewBox="0 0 33 60"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.53917 1.66754L32.1636 27.8206C32.4677 28.1319 32.6827 28.4692 32.8084 28.8325C32.9361 29.1957 33 29.5849 33 30C33 30.4151 32.9361 30.8043 32.8084 31.1675C32.6827 31.5308 32.4677 31.8681 32.1636 32.1794L6.53917 58.4103C5.82949 59.1368 4.9424 59.5 3.87788 59.5C2.81337 59.5 1.90092 59.1108 1.14056 58.3325C0.380188 57.5541 3.56519e-06 56.646 3.47446e-06 55.6082C3.38373e-06 54.5704 0.380187 53.6623 1.14056 52.8839L23.4954 30L1.14055 7.1161C0.430873 6.38962 0.0760336 5.49502 0.0760335 4.4323C0.0760335 3.3675 0.456218 2.44591 1.21659 1.66754C1.97695 0.889182 2.86405 0.499999 3.87788 0.499999C4.8917 0.499999 5.7788 0.889182 6.53917 1.66754Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
            );
          })}
        </div>
        <div
          className={`w-[20rem] bg-white flex flex-col gap-4 absolute h-full z-[2] top-0 ${menuOpen === null ? "-right-0" : "-right-full"
            }`}
          onMouseEnter={(e) => {
            e.stopPropagation();
            // clearTimeout(shopMenuCloseTimeOutRef.current);
            // console.log(
            //   "shop timeout cleared act",
            //   shopMenuCloseTimeOutRef.current
            // );
            // shopMenuCloseTimeOutRef.current = undefined;
          }}
          onMouseLeave={() => handleMouseOverNotshopMenuZone()}
        >
          {menuOpen !== null ? (
            shopData[menuOpen].items.map((data, index) => (
              <a
                href={data.link}
                key={index}
                className="text-black hover:text-[#84CC16] transition-all duration-300 ease-in-out"
              >
                {data.title}
                {data.withTradeMark && <span>&#8482;</span>}
              </a>
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="flex-1 grid grid-cols-3 gap-10 pl-10 items-center justify-center">
        <OnDemandImage src={shop1} src2={shop01} alt="" />
        <OnDemandImage src={shop2} src2={shop02} alt="" />
        <OnDemandImage src={shop3} src2={shop03} alt="" />
      </div>
    </div>
  );
};

const OnDemandImage: FC<OnDemandImageProps> = ({
  src2,
  src,
  alt,
  ...props
}) => {
  const [img, setImg] = useState(src);
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current?.addEventListener("mouseover", () =>
        videoRef.current?.play()
      );
      videoRef.current?.addEventListener("mouseleave", () =>
        videoRef.current?.pause()
      );

      return () => {
        videoRef.current?.removeEventListener("mouseover", () => { });
        videoRef.current?.removeEventListener("mouseleave", () => { });
      };
    }
  }, []);

  return (
    <video
      src={src}
      ref={videoRef}
      {...props}
      width="100%"
      muted
      loop
      height="100%"
      className="cursor-pointer"
    />
  );
};

export default ShopNavMenu;
